import { createSlice } from "@reduxjs/toolkit";

const initialCustomersState = { list: [], selected: undefined };

const customersSlice = createSlice({
  name: "customers",
  initialState: initialCustomersState,
  reducers: {
    set(state, action) {
      state.list = action.payload.map((c) => {
        return {
          id: c.id,
          name: c.name,
          email: c.email,
          company: c.company,
          licensesCount: c.licenses.length,
        };
      });
    },
    add(state, action) {
      state.list.push({ ...action.payload, licensesCount: 0 });
    },
    del(state, action) {
      state.list = state.list.filter((c) => c.id !== action.payload);
      state.selected = null;
    },
    upd(state, action) {
      const customerIndex = state.list.findIndex(
        (c) => c.id === action.payload.customer.id
      );
      state.list[customerIndex] = action.updatedCustomer;
    },
    setCustomer(state, action) {
      state.selected = action.payload;
    },
    resetSelected(state) {
      state.selected = undefined;
    },
    setName(state, action) {
      state.selected.name = action.payload;
    },
    setCompany(state, action) {
      state.selected.company = action.payload;
    }
  },
});

export const customersActions = customersSlice.actions;
export default customersSlice.reducer;
